/** CFO 分析工具 mock 数据（接口不可用时展示） */

export const MOCK_PL_STATEMENT = [
  { is_section: true, account_name: '收入' },
  { account_name: '主营业务收入', actual_wan: 40600, budget_wan: 42000, diff_wan: -1400, diff_pct: -3.3, prior_year_wan: 41800, ytd_actual_wan: 203000, ytd_budget_wan: 210000, ytd_diff_wan: -7000, full_year_forecast_wan: 487200, highlight: true, show_dot: true },
  { account_name: '其中：内单收入', indent: true, actual_wan: 28420, budget_wan: 29400, diff_wan: -980, diff_pct: -3.3, prior_year_wan: 28800, ytd_actual_wan: 142100, ytd_budget_wan: 147000, ytd_diff_wan: -4900, full_year_forecast_wan: 341040, fy_muted: true },
  { account_name: '其中：外单收入', indent: true, actual_wan: 12180, budget_wan: 12600, diff_wan: -420, diff_pct: -3.3, prior_year_wan: 13000, ytd_actual_wan: 60900, ytd_budget_wan: 63000, ytd_diff_wan: -2100, full_year_forecast_wan: 146160, fy_muted: true },
  { is_section: true, account_name: '成本' },
  { account_name: '主营业务成本', actual_wan: 34713, budget_wan: 35280, diff_wan: -567, diff_pct: -1.6, prior_year_wan: 35100, ytd_actual_wan: 173565, ytd_budget_wan: 176400, ytd_diff_wan: -2835, full_year_forecast_wan: 409248, show_dot: true, invert_variance: true },
  { account_name: '其中：直接材料', indent: true, actual_wan: 20828, budget_wan: 21168, diff_wan: -340, diff_pct: -1.6, prior_year_wan: 21060, ytd_actual_wan: 104140, ytd_budget_wan: 105840, ytd_diff_wan: -1700, full_year_forecast_wan: 245549, fy_muted: true, invert_variance: true },
  { account_name: '其中：制造人工', indent: true, actual_wan: 6248, budget_wan: 6350, diff_wan: -102, diff_pct: -1.6, prior_year_wan: 6318, ytd_actual_wan: 31240, ytd_budget_wan: 31750, ytd_diff_wan: -510, full_year_forecast_wan: 73665, fy_muted: true, invert_variance: true },
  { account_name: '其中：制造费用', indent: true, actual_wan: 7637, budget_wan: 7762, diff_wan: -125, diff_pct: -1.6, prior_year_wan: 7722, ytd_actual_wan: 38185, ytd_budget_wan: 38810, ytd_diff_wan: -625, full_year_forecast_wan: 90034, fy_muted: true, invert_variance: true },
  { account_name: '毛利', is_subtotal: true, actual_wan: 5887, budget_wan: 6720, diff_wan: -833, diff_pct: -12.4, prior_year_wan: 6700, ytd_actual_wan: 29435, ytd_budget_wan: 33600, ytd_diff_wan: -4165, full_year_forecast_wan: 77952, fy_bold: true },
  { account_name: '毛利率', is_subtotal: true, is_pct: true, is_pp: true, actual_wan: 14.5, budget_wan: 16.0, diff_wan: -1.5, prior_year_wan: 16.0, ytd_actual_wan: 14.5, ytd_budget_wan: 16.0, ytd_diff_wan: -1.5, full_year_forecast_wan: 16.0, fy_bold: true },
  { is_section: true, account_name: '费用' },
  { account_name: '销售费用', actual_wan: 5800, budget_wan: 5600, diff_wan: 200, diff_pct: 3.6, prior_year_wan: 5500, ytd_actual_wan: 28500, ytd_budget_wan: 27500, ytd_diff_wan: 1000, full_year_forecast_wan: 69600, expense_bad: true, fy_muted: true },
  { account_name: '占收入比', indent: true, is_pct: true, is_pp: true, actual_wan: 14.3, budget_wan: 13.3, diff_wan: 1.0, prior_year_wan: 13.2, ytd_actual_wan: 14.0, ytd_budget_wan: 13.1, ytd_diff_wan: 0.9, full_year_forecast_wan: 14.3, expense_bad: true },
  { account_name: '管理费用', actual_wan: 2200, budget_wan: 2100, diff_wan: 100, diff_pct: 4.8, prior_year_wan: 2050, ytd_actual_wan: 10800, ytd_budget_wan: 10500, ytd_diff_wan: 300, full_year_forecast_wan: 26400, expense_bad: true, fy_muted: true },
  { account_name: '研发费用', actual_wan: 1600, budget_wan: 1550, diff_wan: 50, diff_pct: 3.2, prior_year_wan: 1500, ytd_actual_wan: 7900, ytd_budget_wan: 7750, ytd_diff_wan: 150, full_year_forecast_wan: 19200, expense_bad: true, fy_muted: true },
  { account_name: '费用合计', is_subtotal: true, actual_wan: 9600, budget_wan: 9250, diff_wan: 350, diff_pct: 3.8, prior_year_wan: 9050, ytd_actual_wan: 47200, ytd_budget_wan: 45750, ytd_diff_wan: 1450, full_year_forecast_wan: 115200, expense_bad: true, fy_muted: true },
  { is_section: true, account_name: '利润' },
  { account_name: '经营利润', is_subtotal: true, highlight: true, actual_wan: -3713, budget_wan: -2530, diff_wan: -1183, prior_year_wan: -2350, ytd_actual_wan: -17765, ytd_budget_wan: -12150, ytd_diff_wan: -5615, full_year_forecast_wan: -37248, fy_bold: true, budget_positive: true },
  { account_name: '经营利润率', is_subtotal: true, is_pct: true, is_pp: true, actual_wan: -9.1, budget_wan: -6.0, diff_wan: -3.1, prior_year_wan: -5.6, ytd_actual_wan: -8.8, ytd_budget_wan: -5.8, ytd_diff_wan: -3.0, full_year_forecast_wan: -7.6, fy_bold: true },
  { account_name: '财务费用(净)', actual_wan: 280, budget_wan: 260, diff_wan: 20, diff_pct: 7.7, prior_year_wan: 250, ytd_actual_wan: 1380, ytd_budget_wan: 1300, ytd_diff_wan: 80, full_year_forecast_wan: 3360, expense_bad: true, fy_muted: true },
  { account_name: '净利润', is_subtotal: true, actual_wan: -3993, budget_wan: -2790, diff_wan: -1203, prior_year_wan: -2600, ytd_actual_wan: -19145, ytd_budget_wan: -13450, ytd_diff_wan: -5695, full_year_forecast_wan: -40608, fy_bold: true }
]

export const MOCK_REVENUE_ATTRIBUTION = [
  { attr_name: '量差', impact_wan: -840, impact_pct: 0.6, description: 'BOM涨价致订单延迟，在手订单覆盖度82%，新品爬坡出货低于预期', breakdown: '占收入差的 60.0%' },
  { attr_name: '价差', impact_wan: -360, impact_pct: 0.257, description: 'BOM成本传导滞后，返利兑现超预算+80万，外单ASP低于内单5.2%', breakdown: '占收入差的 25.7%' },
  { attr_name: '结构差', impact_wan: -200, impact_pct: 0.143, description: '高毛利产品占比降3.8pp，低毛利产品占比上升，华东降华南升', breakdown: '占收入差的 14.3%' }
]

export const MOCK_GM_TREND = [
  { period_key: 202601, period_label: '2026年1月', revenue_wan: 42500, gross_profit_wan: 7600, gross_margin_pct: 17.88, operating_profit_wan: -1800 },
  { period_key: 202602, period_label: '2026年2月', revenue_wan: 41200, gross_profit_wan: 7100, gross_margin_pct: 17.23, operating_profit_wan: -2100 },
  { period_key: 202603, period_label: '2026年3月', revenue_wan: 43800, gross_profit_wan: 6800, gross_margin_pct: 15.53, operating_profit_wan: -2800 },
  { period_key: 202604, period_label: '2026年4月', revenue_wan: 42100, gross_profit_wan: 6200, gross_margin_pct: 14.73, operating_profit_wan: -3200 },
  { period_key: 202605, period_label: '2026年5月', revenue_wan: 40600, gross_profit_wan: 5887, gross_margin_pct: 14.5, operating_profit_wan: -3713 },
  { period_key: 202606, period_label: '2026年6月', revenue_wan: 40500, gross_profit_wan: 6100, gross_margin_pct: 15.06, operating_profit_wan: -3400 },
  { period_key: 202607, period_label: '2026年7月', revenue_wan: 41800, gross_profit_wan: 6500, gross_margin_pct: 15.55, operating_profit_wan: -2900 }
]

export const MOCK_ROLLING_FORECAST = [
  { period_key: 202606, account_code: 'REV', forecast_wan: 40500, confidence_level: 0.8 },
  { period_key: 202607, account_code: 'REV', forecast_wan: 41800, confidence_level: 0.75 },
  { period_key: 202608, account_code: 'REV', forecast_wan: 43200, confidence_level: 0.7 },
  { period_key: 202606, account_code: 'GM', forecast_wan: 15.1, confidence_level: 0.65 },
  { period_key: 202607, account_code: 'GM', forecast_wan: 15.6, confidence_level: 0.6 },
  { period_key: 202608, account_code: 'GM', forecast_wan: 16.2, confidence_level: 0.55 }
]

/** 7+3 滚动预测 · 最小可行 P&L（对齐 cfo-module-fpa-2.html） */
export const MOCK_ROLLING_PNL = {
  meta: {
    update_freq: '每周五',
    data_cutoff: '6月13日',
    order_coverage: 87
  },
  rows: [
    { type: 'section', title: '收入' },
    {
      type: 'data', account_code: 'REV', account_name: '主营业务收入',
      may_actual: 46143, q1_actual: 139800, jun_fcst: 47500, q2_fcst: 141000, q3_fcst: 147600, fy_fcst: 560000,
      confidence: 0.8, jun_bold: true, fy_bold: true
    },
    { type: 'assumption', text: '假设: 在手订单覆盖度87% + 新签订单预期 | 内单涨价兑现率Q2:72%→Q3:78% | 新品S2系列Q3量产+1,200万/月 | 全年含材差补价合约收入约8,400万' },
    { type: 'section', title: '成本' },
    {
      type: 'data', account_code: 'COST', account_name: '主营业务成本',
      may_actual: 35012, q1_actual: 104800, jun_fcst: 35500, q2_fcst: 105300, q3_fcst: 108400, fy_fcst: 392000,
      confidence: 0.8, jun_bold: true, fy_bold: true
    },
    { type: 'assumption', text: '假设: 材料占比60.5%→Q3降至59% | 制造费用含产能利用率提升至72%+ | 采购降本Q3兑现率目标85%' },
    {
      type: 'data', account_code: 'MAT', account_name: '其中：材料成本（含材差）', row_class: 'material',
      may_actual: 21007, q1_actual: 63000, jun_fcst: 21300, q2_fcst: 63500, q3_fcst: 64300, fy_fcst: 231280,
      confidence: 0.5, may_red: true, jun_bold: true, fy_bold: true
    },
    {
      type: 'data', account_code: 'STD_VAR', account_name: '└ 标准成本材差（SAP标准价vs实际价）',
      row_class: 'material', indent: true, small: true,
      may_actual: -180, q1_actual: -520, jun_fcst: -160, q2_fcst: -480, q3_fcst: -350, fy_fcst: -1500,
      confidence: 0.5, all_red: true
    },
    {
      type: 'data', account_code: 'MKT_VAR', account_name: '└ 实际市价变动（大宗盯市）',
      row_class: 'material', indent: true, small: true,
      may_actual: -210, q1_actual: -610, jun_fcst: -200, q2_fcst: -600, q3_fcst: -420, fy_fcst: -1800,
      confidence: 0.5, may_red: true, fcst_amber: true
    },
    { type: 'assumption', text: '材差假设: 铜LME Q3预测区间$9,200-$9,800/t | 钢材(HRC) Q3预测￥3,600-3,900/t | PCB板预计Q3降价2-3% | 现货/合约比当前65:35，目标调整至55:45' },
    {
      type: 'data', account_code: 'GP', account_name: '毛利', row_class: 'bottom',
      may_actual: 11131, q1_actual: 35000, jun_fcst: 12000, q2_fcst: 35700, q3_fcst: 39200, fy_fcst: 168000,
      confidence: 0.8, may_red: true, jun_blue: true, q2_blue: true, q3_green: true, fy_bold: true
    },
    {
      type: 'data', account_code: 'GM', account_name: '毛利率', row_class: 'bottom', is_pct: true,
      may_actual: 24.1, q1_actual: 25.0, jun_fcst: 25.3, q2_fcst: 25.3, q3_fcst: 26.6, fy_fcst: 30.0,
      confidence: 0.5, may_red: true, jun_blue: true, q3_green: true, fy_bold: true
    },
    { type: 'section', title: '费用' },
    {
      type: 'data', account_code: 'SELL', account_name: '销售费用',
      may_actual: 8200, q1_actual: 23800, jun_fcst: 8100, q2_fcst: 24200, q3_fcst: 24800, fy_fcst: 96000,
      confidence: 0.8
    },
    {
      type: 'data', account_code: 'ADMIN', account_name: '管理费用',
      may_actual: 3100, q1_actual: 9000, jun_fcst: 3050, q2_fcst: 9100, q3_fcst: 9300, fy_fcst: 37000,
      confidence: 0.8
    },
    {
      type: 'data', account_code: 'RD', account_name: '研发费用',
      may_actual: 2560, q1_actual: 7400, jun_fcst: 2550, q2_fcst: 7600, q3_fcst: 7800, fy_fcst: 30000,
      confidence: 0.8
    },
    {
      type: 'data', account_code: 'OPEX', account_name: '费用合计', row_class: 'bottom',
      may_actual: 13860, q1_actual: 40200, jun_fcst: 13700, q2_fcst: 40900, q3_fcst: 41900, fy_fcst: 163000,
      confidence: 0.8, jun_bold: true, q2_bold: true, q3_bold: true, fy_bold: true
    },
    { type: 'section', title: '利润' },
    {
      type: 'data', account_code: 'OP', account_name: '经营利润', row_class: 'bottom',
      may_actual: -2729, q1_actual: -5200, jun_fcst: -1700, q2_fcst: -5200, q3_fcst: -2700, fy_fcst: 5000,
      confidence: 0.5, may_red: true, q1_red: true, jun_red: true, q2_red: true, q3_amber: true, fy_bold: true
    },
    {
      type: 'data', account_code: 'NP', account_name: '净利润', row_class: 'bottom',
      may_actual: -3149, q1_actual: -6400, jun_fcst: -2100, q2_fcst: -6500, q3_fcst: -3800, fy_fcst: 200,
      confidence: 0.5, may_red: true, q1_red: true, jun_red: true, q2_red: true, q3_amber: true, fy_bold: true
    }
  ],
  summary_cards: [
    {
      tone: 'green',
      title: '80%置信区间（全年收入）',
      value: '45.3亿 ~ 49.1亿',
      sub: '基准48.7亿 | 下行：BOM持续涨价·订单延迟 | 上行：替代料锁价落地'
    },
    {
      tone: 'amber',
      title: '50%置信区间（全年GM）',
      value: '14.8% ~ 16.2%',
      sub: '基准15.2% | BOM材差±412万/月是最大变量 | 兑现率40%→实际15.2%'
    },
    {
      tone: 'red',
      title: '关键预警',
      value: '四项关差动作兑现率仅40%',
      sub: '兑现率40%→15.2%，100%→16.15%超目标 | 优先级：替代料锁价',
      value_small: true
    }
  ],
  footnote: '预测方法论：收入基于在手订单×覆盖度+新签概率加权 | 毛利预测中BOM材差基于PCB/铜/锡价格盯市（LME铜、PCB指数），材差占毛利方差的60%以上 | 兑现率加权基于四项关差动作当前进度(35%/42%/52%/25%) | 替代料锁价覆盖率为毛利率回升最大单一杠杆。'
}

export const MOCK_WHATIF = {
  impact: {
    period_label: '2026年5月',
    revenue_wan: 46143,
    gross_profit_wan: 11131,
    operating_profit_wan: -2729,
    gross_margin_pct: 24.12,
    budget_op_wan: -2530,
    target_gm_pct: 30.5,
    gm_gap_pp: 6.38,
    op_vs_budget_wan: -199
  },
  parameters: [
    { param_code: 'commodity_change', param_name: '大宗商品涨跌幅', unit: '%', range_min: -10, range_max: 20, baseline: 5, gp_elasticity: 58, step: 0.5, description: '铜/钢/PCB综合指数同比变动' },
    { param_code: 'price_rate', param_name: '内单涨价兑现率', unit: '%', range_min: 40, range_max: 100, baseline: 75, gp_elasticity: 46, step: 1, description: '已签涨价合同的执行比例' },
    { param_code: 'cost_down', param_name: '采购降本完成率', unit: '%', range_min: 50, range_max: 120, baseline: 70, gp_elasticity: 18, step: 1, description: '年度采购降本目标完成进度' },
    { param_code: 'capacity', param_name: '产能利用率', unit: '%', range_min: 55, range_max: 95, baseline: 62, gp_elasticity: 22, step: 1, description: '制造产能利用水平' }
  ],
  presets: [
    { preset_name: '保守', commodity_change: 12, price_rate: 50, cost_down: 60, capacity: 58, result_gm_pct: 21.8 },
    { preset_name: '基准', commodity_change: 5, price_rate: 75, cost_down: 70, capacity: 62, result_gm_pct: 24.1 },
    { preset_name: '激进', commodity_change: -3, price_rate: 90, cost_down: 110, capacity: 80, result_gm_pct: 27.9 }
  ]
}

export const MOCK_SENSITIVITY = [
  { factor: '内单价格调整', most: true, cells: [-7.0, -3.5, 0, 3.5, 7.0], elasticity: '0.700 pp / 1%' },
  { factor: '大宗商品涨价', cells: [3.64, 1.82, 0, -1.82, -3.64], elasticity: '0.364 pp / 1%' },
  { factor: '产能利用率', cells: [-0.89, -0.45, 0, 0.45, 0.89], elasticity: '0.089 pp / 1%' },
  { factor: '采购降本完成率', cells: [-0.55, -0.27, 0, 0.27, 0.55], elasticity: '0.055 pp / 1%' },
  { factor: '质量损失率', cells: [0.23, 0.11, 0, -0.11, -0.23], elasticity: '0.023 pp / 1%' }
]

export const MOCK_PRICE_VARIANCE = [
  { material: '铜材 LME', std_price: 68500, actual_price: 71200, variance_wan: -180, status: '超支' },
  { material: '冷轧钢 HRC', std_price: 3680, actual_price: 3920, variance_wan: -210, status: '超支' },
  { material: 'PCB 4层板', std_price: 42.5, actual_price: 41.2, variance_wan: 68, status: '节约' },
  { material: '锡锭', std_price: 228000, actual_price: 235500, variance_wan: -95, status: '超支' },
  { material: '铝型材', std_price: 18500, actual_price: 18100, variance_wan: 42, status: '节约' }
]

export const MOCK_MATERIAL_VARIANCE = [
  { period_label: '2026年5月', material_name: '钢材', procurement_wan: 10000, std_var_wan: -90, market_var_wan: -50, total_var_wan: -140, var_rate_pct: -1.4, var_share_pct: 34, gm_erosion_pp: 0.35 },
  { period_label: '2026年5月', material_name: '铜材', procurement_wan: 8100, std_var_wan: -85, market_var_wan: -45, total_var_wan: -130, var_rate_pct: -1.6, var_share_pct: 31.6, gm_erosion_pp: 0.3 },
  { period_label: '2026年5月', material_name: 'PCB板', procurement_wan: 3300, std_var_wan: -55, market_var_wan: -30, total_var_wan: -85, var_rate_pct: -2.58, var_share_pct: 20.6, gm_erosion_pp: 0.22 },
  { period_label: '2026年5月', material_name: '其他', procurement_wan: 1900, std_var_wan: -32, market_var_wan: -25, total_var_wan: -57, var_rate_pct: -3, var_share_pct: 13.8, gm_erosion_pp: 0.15 }
]

export const MOCK_COMMODITY_QUOTES = [
  { commodity_code: 'LME_COPPER', commodity_name: 'LME铜', price: 9780, currency: 'USD', price_unit: '美元/吨', price_date: '2026-07-15' },
  { commodity_code: 'HRC_STEEL', commodity_name: 'HRC热轧钢', price: 3810, currency: 'CNY', price_unit: '元/吨', price_date: '2026-07-15' },
  { commodity_code: 'PCB_IDX', commodity_name: 'PCB行业指数', price: 96.5, currency: 'CNY', price_unit: '指数点', price_date: '2026-07-15' }
]

export const MOCK_COMMODITY_HISTORY = {
  LME_COPPER: [
    { price_date: '2026-01-15', price: 9350 },
    { price_date: '2026-03-15', price: 9580 },
    { price_date: '2026-05-15', price: 9720 },
    { price_date: '2026-07-15', price: 9780 }
  ],
  HRC_STEEL: [
    { price_date: '2026-01-15', price: 3520 },
    { price_date: '2026-03-15', price: 3680 },
    { price_date: '2026-05-15', price: 3760 },
    { price_date: '2026-07-15', price: 3810 }
  ],
  PCB_IDX: [
    { price_date: '2026-01-15', price: 98.2 },
    { price_date: '2026-03-15', price: 97.4 },
    { price_date: '2026-05-15', price: 97.0 },
    { price_date: '2026-07-15', price: 96.5 }
  ]
}

export const MOCK_FORECAST_BACKTEST = [
  { period: '2026年3月', forecast_gm: 16.2, actual_gm: 15.53, bias: -0.67 },
  { period: '2026年4月', forecast_gm: 15.8, actual_gm: 14.73, bias: -1.07 },
  { period: '2026年5月', forecast_gm: 15.5, actual_gm: 14.5, bias: -1.0 }
]

/** 预测准确率回溯 mock（对齐 cfo-module-fa-3.html） */
export const MOCK_FORECAST_ACCURACY = {
  period_key: 202605,
  period_label: '2026年5月',
  forecast_base_date: '2026-05-15',
  gm_deviation_pp: -0.67,
  profit_deviation_wan: -829,
  compare_rows: [
    { row_type: 'data', account_name: '主营业务收入', forecast_wan: 47200, actual_wan: 46143, deviation_wan: -1057, deviation_pct: -2.24, direction: '高估' },
    { row_type: 'sub', account_name: '其中: 内单收入', forecast_wan: 33100, actual_wan: 32300, deviation_wan: -800, deviation_pct: -2.42, direction: '高估' },
    { row_type: 'sub', account_name: '其中: 外单收入', forecast_wan: 14100, actual_wan: 13843, deviation_wan: -257, deviation_pct: -1.82, direction: '高估' },
    { row_type: 'section', account_name: '成本' },
    { row_type: 'data', account_name: '主营业务成本', forecast_wan: 35500, actual_wan: 35012, deviation_wan: 488, deviation_pct: 1.39, direction: '低估' },
    { row_type: 'sub', account_name: '其中: 直接材料(含材差)', forecast_wan: 21500, actual_wan: 21007, deviation_wan: 493, deviation_pct: 2.35, direction: '低估' },
    { row_type: 'sub', account_name: '其中: 制造人工', forecast_wan: 6400, actual_wan: 6302, deviation_wan: 98, deviation_pct: 1.55, direction: '低估' },
    { row_type: 'sub', account_name: '其中: 制造费用', forecast_wan: 7600, actual_wan: 7703, deviation_wan: -103, deviation_pct: -1.34, direction: '低估' },
    { row_type: 'section', account_name: '利润' },
    { row_type: 'total', account_name: '毛利', forecast_wan: 11700, actual_wan: 11131, deviation_wan: -569, deviation_pct: -4.86, direction: '高估' },
    { row_type: 'total', account_name: '毛利率', forecast_wan: 24.79, actual_wan: 24.12, deviation_wan: -0.67, deviation_pct: null, direction: '高估', is_pct: true },
    { row_type: 'section', account_name: '费用' },
    { row_type: 'data', account_name: '费用合计', forecast_wan: 13600, actual_wan: 13860, deviation_wan: -260, deviation_pct: -1.87, direction: '低估' },
    { row_type: 'total', account_name: '经营利润', forecast_wan: -1900, actual_wan: -2729, deviation_wan: -829, deviation_pct: -43.6, direction: '高估' }
  ],
  decomposition: [
    { label: '收入偏差', value: -1057, desc: '高估收入', color: 'red' },
    { label: '成本偏差', value: 488, desc: '高估成本(有利)', color: 'green' },
    { label: '费用偏差', value: -260, desc: '低估费用', color: 'red' },
    { label: '经营利润偏差', value: -829, desc: '万元', color: 'red', is_total: true }
  ],
  decomposition_note: '收入高估(-1,057万)是经营利润偏差(-829万)的主要驱动，部分被成本高估(+488万)抵消。成本高估主要来源于材差预测过高(+493万材料成本高估)，说明SAP标准价材差模型对大宗上行趋势的预测偏保守。',
  trend: [
    { period_label: '3月', rev: 98.5, cost: 99.4, gp: 92.8, opex: 99.2 },
    { period_label: '4月', rev: 97.9, cost: 98.6, gp: 88.6, opex: 99.0 },
    { period_label: '5月', rev: 97.7, cost: 98.5, gp: 85.9, opex: 98.1 }
  ],
  bias: {
    systematic_pct: 68,
    random_pct: 32,
    systematic_desc: '收入: 连续3个月高估(均值-2.0%)\n材料成本: 连续3个月高估(均值+1.7%)\n根因: 在手订单覆盖度假定偏乐观(使用85%而非实际75%)；SAP标准价未及时反映大宗实际涨幅，导致材差预测系统性偏低。',
    random_desc: '制造费用: 5月单月偏差-103万(设备突发维修)\n费用: 5月销售费用超预测+100万(华南客户专项活动)\n说明: 随机偏差占比不高但波动大。制造费用和设备维修的偶发性难以在月度预测模型中捕捉。'
  },
  recommendations: [
    { level: 'red', text: '1. 订单覆盖度假设下调: 将收入预测中的在手订单覆盖度从85%下调至78%，与近3个月实际均值(76%)对齐。' },
    { level: 'red', text: '2. 材差预测模型校准: SAP标准价更新滞后是成本预测偏差的最大来源。建议在7+3预测中增加"大宗盯市调整因子"。' },
    { level: 'amber', text: '3. 费用预测季节性: 当前费用预测使用简单线性分摊，建议增加季节性因子和已知专项活动预提。' }
  ],
  footnote: '预测准确率计算口径: 准确率 = 1 - |预测值 - 实际值| / 实际值 × 100%。上月预测定义为上月15日发布的7+3滚动预测中对本月的预测值。系统偏差定义为连续3个月同方向偏差的科目偏差绝对值之和占总偏差的比例。当前系统偏差占比68%说明预测模型存在结构性缺陷，应优先修复订单覆盖度假定和材差预测模型两个最大偏差源。'
}

/** API sections 形态（实际接口返回） */
export const MOCK_FORECAST_ACCURACY_SECTIONS = {
  period_key: 202605,
  period_label: '2026年5月',
  basis_note: '上月7+3滚动预测 vs 本月实际',
  basis_date: '2026-05-15',
  rolling_months: 3,
  update_freq: '月结后5个工作日',
  distinguish_bias: true,
  summary: {
    gm_deviation_pp: -0.67,
    gm_forecast: 24.79,
    gm_actual: 24.12
  },
  sections: [
    {
      group: '收入',
      expanded: true,
      rows: [
        { account_code: 'REV', account_name: '主营业务收入', indent: 0, is_sub: false, is_rate: false, forecast: 47200.0, actual: 46143.0, deviation: -1057.0, deviation_pct: -2.2, direction: '高估' },
        { account_code: 'REV_IN', account_name: '其中: 内单收入', indent: 1, is_sub: true, is_rate: false, forecast: 32917.5, actual: 28420.0, deviation: -4497.5, deviation_pct: -13.7, direction: '高估' },
        { account_code: 'REV_EX', account_name: '其中: 外单收入', indent: 1, is_sub: true, is_rate: false, forecast: 14107.5, actual: 12180.0, deviation: -1927.5, deviation_pct: -13.7, direction: '高估' }
      ]
    },
    {
      group: '成本',
      expanded: true,
      rows: [
        { account_code: 'COST', account_name: '主营业务成本', indent: 0, is_sub: false, is_rate: false, forecast: 35500.0, actual: 35012.0, deviation: -488.0, deviation_pct: -1.4, direction: '高估' },
        { account_code: 'COST_MAT', account_name: '其中: 直接材料(含材差)', indent: 1, is_sub: true, is_rate: false, forecast: 21087.0, actual: 20540.0, deviation: -547.0, deviation_pct: -2.6, direction: '高估' },
        { account_code: 'COST_LAB', account_name: '其中: 制造人工', indent: 1, is_sub: true, is_rate: false, forecast: 6187.5, actual: 5100.0, deviation: -1087.5, deviation_pct: -17.6, direction: '高估' },
        { account_code: 'COST_MFG', account_name: '其中: 制造费用', indent: 1, is_sub: true, is_rate: false, forecast: 7870.5, actual: 9073.0, deviation: 1202.5, deviation_pct: 15.3, direction: '低估' }
      ]
    },
    {
      group: '利润',
      expanded: true,
      rows: [
        { account_code: 'GP', account_name: '毛利', indent: 0, is_sub: false, is_rate: false, forecast: 11700.0, actual: 11131.0, deviation: -569.0, deviation_pct: -4.9, direction: '高估' },
        { account_code: 'GP_RATE', account_name: '毛利率', indent: 0, is_sub: false, is_rate: true, forecast: 24.79, actual: 24.12, deviation: -0.67, deviation_pct: null, direction: '高估' }
      ]
    },
    {
      group: '费用',
      expanded: true,
      rows: [
        { account_code: 'OPEX', account_name: '费用合计', indent: 0, is_sub: false, is_rate: false, forecast: 13600.0, actual: 13860.0, deviation: 260.0, deviation_pct: 1.9, direction: '低估' },
        { account_code: 'OP', account_name: '经营利润', indent: 0, is_sub: false, is_rate: false, forecast: -1683.0, actual: -3713.0, deviation: -2030.0, deviation_pct: -120.6, direction: '高估' }
      ]
    }
  ]
}

/** API 扁平数组形态（文档示例） */
export const MOCK_FORECAST_ACCURACY_ROWS = [
  { period_key: 202605, period_label: '2026年5月', account_code: 'REV', account_name: '主营业务收入', forecast_wan: 47200, actual_wan: 46143, deviation_wan: -1057, deviation_pct: -2.24, accuracy_pct: 97.76, bias_type: 'systematic' },
  { period_key: 202605, period_label: '2026年5月', account_code: 'COST', account_name: '主营业务成本', forecast_wan: 35500, actual_wan: 35012, deviation_wan: 488, deviation_pct: 1.39, accuracy_pct: 98.53, bias_type: 'systematic' },
  { period_key: 202605, period_label: '2026年5月', account_code: 'GP', account_name: '毛利', forecast_wan: 11700, actual_wan: 11131, deviation_wan: -569, deviation_pct: -4.86, accuracy_pct: 85.89, bias_type: 'systematic' },
  { period_key: 202605, period_label: '2026年5月', account_code: 'OPEX', account_name: '费用合计', forecast_wan: 13600, actual_wan: 13860, deviation_wan: -260, deviation_pct: -1.88, accuracy_pct: 98.12, bias_type: 'random' },
  { period_key: 202604, period_label: '2026年4月', account_code: 'REV', account_name: '主营业务收入', forecast_wan: 47000, actual_wan: 45900, deviation_wan: -1100, deviation_pct: -2.34, accuracy_pct: 97.6, bias_type: 'systematic' },
  { period_key: 202604, period_label: '2026年4月', account_code: 'COST', account_name: '主营业务成本', forecast_wan: 35200, actual_wan: 34700, deviation_wan: 500, deviation_pct: 1.44, accuracy_pct: 98.56, bias_type: 'systematic' },
  { period_key: 202604, period_label: '2026年4月', account_code: 'GP', account_name: '毛利', forecast_wan: 11800, actual_wan: 11200, deviation_wan: -600, deviation_pct: -5.08, accuracy_pct: 88.6, bias_type: 'systematic' },
  { period_key: 202604, period_label: '2026年4月', account_code: 'OPEX', account_name: '费用合计', forecast_wan: 13500, actual_wan: 13650, deviation_wan: -150, deviation_pct: -1.11, accuracy_pct: 99.0, bias_type: 'random' },
  { period_key: 202603, period_label: '2026年3月', account_code: 'REV', account_name: '主营业务收入', forecast_wan: 46800, actual_wan: 46100, deviation_wan: -700, deviation_pct: -1.52, accuracy_pct: 98.5, bias_type: 'systematic' },
  { period_key: 202603, period_label: '2026年3月', account_code: 'COST', account_name: '主营业务成本', forecast_wan: 34800, actual_wan: 34400, deviation_wan: 400, deviation_pct: 1.16, accuracy_pct: 99.4, bias_type: 'systematic' },
  { period_key: 202603, period_label: '2026年3月', account_code: 'GP', account_name: '毛利', forecast_wan: 12000, actual_wan: 11700, deviation_wan: -300, deviation_pct: -2.5, accuracy_pct: 92.8, bias_type: 'systematic' },
  { period_key: 202603, period_label: '2026年3月', account_code: 'OPEX', account_name: '费用合计', forecast_wan: 13400, actual_wan: 13510, deviation_wan: -110, deviation_pct: -0.82, accuracy_pct: 99.2, bias_type: 'random' }
]

export const MOCK_CLOSING_STEPS = [
  { name: '收入确认', status: 'done', owner: '销售财务', deadline: 'D+2' },
  { name: '成本结转', status: 'done', owner: '成本会计', deadline: 'D+3' },
  { name: '材差分析', status: 'active', owner: '管理会计', deadline: 'D+4' },
  { name: '费用预提', status: 'active', owner: '总账', deadline: 'D+5' },
  { name: '合并抵消', status: 'wait', owner: '合并组', deadline: 'D+6' },
  { name: '管理报告', status: 'wait', owner: 'FPA', deadline: 'D+7' }
]

export const MOCK_DATA_TRUST = [
  { domain: '收入', source: 'CRM+SAP', completeness: 98, timeliness: 95, accuracy: 92, score: 95 },
  { domain: '成本', source: 'SAP CO', completeness: 96, timeliness: 90, accuracy: 88, score: 91 },
  { domain: '费用', source: '费控+SAP', completeness: 94, timeliness: 88, accuracy: 90, score: 91 },
  { domain: '现金流', source: 'Treasury', completeness: 99, timeliness: 97, accuracy: 96, score: 97 },
  { domain: '预算', source: 'EPM', completeness: 90, timeliness: 85, accuracy: 87, score: 87 }
]

export const MOCK_CONSISTENCY = [
  { item: '收入口径', sap: '4.06亿', epm: '4.06亿', diff: 0, status: '一致' },
  { item: '直接材料', sap: '2.08亿', epm: '2.07亿', diff: -100, status: '待确认' },
  { item: '制造费用', sap: '0.76亿', epm: '0.76亿', diff: 0, status: '一致' },
  { item: '销售费用', sap: '0.58亿', epm: '0.59亿', diff: 100, status: '待确认' },
  { item: '经营利润', sap: '-0.37亿', epm: '-0.37亿', diff: 0, status: '一致' }
]

export const MOCK_CASHFLOW = {
  metrics: [
    { label: '经营现金流', value: '+2,840万', sub: '环比 +12%' },
    { label: '自由现金流', value: '+1,120万', sub: 'CAPEX 1,720万' },
    { label: '现金余额', value: '3.68亿', sub: '覆盖 4.2 个月' },
    { label: '回款率', value: '94.2%', sub: '目标 95%' }
  ],
  weeks: ['W1', 'W2', 'W3', 'W4'],
  inflow: [8200, 9100, 8800, 9500],
  outflow: [7600, 8200, 7900, 8100]
}

export const MOCK_BUDGET_HEATMAP = {
  depts: ['制造', '销售', '研发', '供应链', '职能'],
  months: ['1月', '2月', '3月', '4月', '5月'],
  values: [
    [92, 88, 95, 91, 87],
    [98, 102, 96, 99, 104],
    [85, 87, 90, 88, 92],
    [78, 82, 80, 85, 83],
    [95, 93, 97, 94, 96]
  ]
}

export const MOCK_WORKING_CAPITAL = [
  { item: '应收账款', amount: 12800, days: 42, target: 38, status: '偏高' },
  { item: '存货', amount: 9600, days: 35, target: 32, status: '偏高' },
  { item: '应付账款', amount: 8200, days: 45, target: 48, status: '正常' },
  { item: '营运资金', amount: 14200, days: 32, target: 28, status: '偏高' }
]
